import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { apiFetch } from '../apiFetch';

export default function PesoSecoesScreen() {
  const { usuario } = useAppContext();
  const clienteId = usuario?.id;
  const [secoes, setSecoes] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!clienteId) return;
    apiFetch(`/api/store-map/${clienteId}/planta`)
      .then(r => r.json())
      .then(d => {
        const lista = (d.secoes || []).map(s => ({ ...s, peso: s.peso || 5 }));
        setSecoes(lista);
      })
      .catch(() => setMsg('Erro ao carregar seções'));
  }, [clienteId]);

  function setPeso(id, peso) {
    setSecoes(prev => prev.map(s => s.id === id ? { ...s, peso } : s));
  }

  async function salvar() {
    setSalvando(true);
    setMsg('');
    try {
      const r = await apiFetch(`/api/store-map/${clienteId}/pesos`, {
        method: 'POST',
        body: JSON.stringify({ secoes: secoes.map(s => ({ id: s.id, peso: s.peso })) }),
      });
      const d = await r.json();
      setMsg(d.ok ? 'Prioridades salvas' : 'Erro ao salvar');
    } catch {
      setMsg('Erro de conexão');
    } finally {
      setSalvando(false);
      setTimeout(() => setMsg(''), 3000);
    }
  }

  return (
    <div>
      <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600, color: 'var(--text-primary)' }}>
        Prioridade das Seções
      </h2>
      <p style={{ margin: '0 0 24px', fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5 }}>
        Defina com que frequência o locutor menciona cada seção.
        Seções com prioridade alta são mencionadas com mais frequência.
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 8,
      }}>
        {secoes.map(s => (
          <div key={s.id} style={{
            background: 'var(--bg-surface)',
            borderRadius: 0,
            padding: '6px 12px',
            border: '1px solid var(--border)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-primary)' }}>{s.nome}</span>
              <span style={{
                fontSize: 13,
                fontWeight: 700,
                color: s.peso >= 8 ? '#22c55e' : s.peso >= 5 ? '#f59e0b' : '#94a3b8',
                minWidth: 32,
                textAlign: 'right',
              }}>{s.peso}/10</span>
            </div>
            <input
              type="range"
              min="1"
              max="10"
              value={s.peso}
              onChange={e => setPeso(s.id, Number(e.target.value))}
              onMouseUp={salvar}
              onTouchEnd={salvar}
              style={{ width: '100%', accentColor: '#4a6fa5' }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#94a3b8', marginTop: 3 }}>
              <span>Raramente</span>
              <span>Com frequência</span>
            </div>
          </div>
        ))}
      </div>

      {secoes.length === 0 && (
        <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
          Nenhuma seção configurada. Configure a planta da loja primeiro.
        </p>
      )}

      {msg && (
        <p style={{
          marginTop: 12,
          textAlign: 'center',
          fontSize: 13,
          color: msg.includes('Erro') ? '#ef4444' : '#22c55e',
        }}>{msg}</p>
      )}
    </div>
  );
}
